import { Component, OnInit } from '@angular/core';
import { NavbarService } from '../navbar.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent {
  outage: any;
  release: any;
  constructor(
    private navbarservice: NavbarService,
    private msalservice: MsalService
  ) {}
  ngOnInit() {
    this.outage = this.navbarservice.outage;
    this.release = this.navbarservice.release;
  }
  outagecolor() {
    this.outage = true;
    this.release = false;
    this.navbarservice.outage = true;
    this.navbarservice.release = false;
  }
  releasecolor() {
    this.outage = false;
    this.release = true;
    this.navbarservice.outage = false;
    this.navbarservice.release = true;
  }
  logout() {
    this.msalservice.logout();
    sessionStorage.clear();
    localStorage.clear();
  }
}
